import React from 'react';
const blocks = [{
  name: 'Open',
  min: 1,
  color: 'bg-white/25',
  text: 'text-white'
}, {
  name: 'Explain',
  min: 1,
  color: 'bg-white/45',
  text: 'text-ink'
}, {
  name: 'Pull a prompt',
  min: 1,
  color: 'bg-amber',
  text: 'text-ink'
}, {
  name: 'Speak — the core',
  min: 6,
  color: 'bg-coral',
  text: 'text-white'
}, {
  name: 'Quick note',
  min: 2,
  color: 'bg-teal',
  text: 'text-white'
}];
const coverage = [{
  label: 'Word-for-word script',
  body: 'The “how to explain it” lines, in quotes. Read them aloud and the room knows exactly what to do'
}, {
  label: 'Students · Club · Adults',
  body: 'Audience tags on every session, plus group size, time and materials (usually just a timer)'
}, {
  label: '5 · 10–12 · 20+ minutes',
  body: 'The Session Formula stretches or shrinks any session to the slot you actually have'
}, {
  label: 'Turns & scoring',
  body: 'Who goes when and how it’s won — so the room never stalls on “who’s next?”'
}, {
  label: 'Mistake + Fix',
  body: 'The thing that usually goes wrong in that session, and what to say when it does'
}, {
  label: 'Three levels',
  body: 'L1 · L2 · L3 plus easier and harder versions, so a mixed room is never bored or buried'
}];
export function ProductReveal() {
  return <section aria-labelledby="mechanism-heading" className="w-full bg-ink text-white" data-id="element-244" data-mp="1jukhggof6ses">
      <div className="wave-strip h-1.5 w-full" aria-hidden="true" data-id="element-245" data-mp="1orawr1sehjz5" />
      <div className="max-w-5xl mx-auto px-5 py-16 sm:py-20 text-center" data-id="element-246" data-mp="s2cyh9lfz3x8">
        <p className="text-[11px] font-semibold uppercase tracking-[1.6px] text-amber" data-id="element-247" data-mp="s4fx2i0nu5dk">The system</p>
        <h2 id="mechanism-heading" className="mt-3 font-display text-3xl font-extrabold text-white sm:text-5xl" data-id="element-248" data-mp="w5hyn5i1utip">
          Open-&amp;-Run Sessions
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-base text-white/80 sm:text-lg" data-id="element-249" data-mp="162npccmr4iie">
          Speaking activities aren&apos;t new. Activities you can actually open
          and run are. A topic list leaves you to build the class; a unit plan
          covers one speech type and stops. Here{' '}
          <span className="font-semibold text-white" data-id="element-250" data-mp="1rrkqsbamjtpb">every session lives on one page</span>{' '}
          with everything you need: the objective, the time, the exact words to
          say, the turns, the scoring, the common mistake and its fix, and three
          levels. <span className="font-semibold text-white" data-id="element-251" data-mp="1ws8iz0alagl4">Open the page, read the script, run it.</span>
        </p>

        <div className="mx-auto mt-9 max-w-3xl text-left" data-id="element-252" data-mp="191l6s2tn54sr">
          <p className="text-[11px] font-semibold uppercase tracking-widest text-white/60" data-id="element-253" data-mp="1901ok6ofcjoc">One shape, every session · a 10–12 minute run</p>
          <div className="mt-2 flex h-11 w-full overflow-hidden rounded-xl border border-ink-line" data-id="element-254" data-mp="1isft176w04e7">
            {blocks.map(b => <div key={b.name} style={{
            flexGrow: b.min,
            flexBasis: 0
          }} className={`${b.color} ${b.text} flex items-center justify-center font-display text-sm font-extrabold sm:text-base`} data-id="element-255" data-mp="1e067s4gpvsi9">
                {b.min}′
              </div>)}
          </div>
          <ol className="mt-3 grid grid-cols-2 gap-x-4 gap-y-1.5 text-[12.5px] text-white/75 sm:grid-cols-5" data-id="element-256" data-mp="31qvlc8zqtjll">
            {blocks.map((b, i) => <li key={b.name} className="flex items-center gap-1.5" data-id="element-257" data-mp="2n3ajeieltqf9" data-mpi={i}>
                <span className={`h-2.5 w-2.5 flex-none rounded-sm ${b.color}`} data-id="element-258" data-mp="2s0j2qmbho0i3" />
                {i + 1}. {b.name}
              </li>)}
          </ol>
        </div>

        <ul className="mt-10 grid gap-2.5 text-left sm:grid-cols-2 lg:grid-cols-3" data-id="element-259" data-mp="3fotumzz7ipu8">
          {coverage.map(item => <li key={item.label} className="rounded-xl border border-ink-line bg-white/5 px-4 py-3" data-id="element-260" data-mp="36qhy6hbnsxtv">
              <span className="block text-[11px] font-semibold uppercase tracking-widest text-amber" data-id="element-261" data-mp="3ar0r6epag9xn">{item.label}</span>
              <span className="mt-1 block text-sm text-white/85" data-id="element-262" data-mp="1v9qjjft9dsc3">{item.body}</span>
            </li>)}
        </ul>
      </div>
    </section>;
}